import { render, staticRenderFns } from "./consolidar.vue?vue&type=template&id=16927908"
import script from "./consolidar.vue?vue&type=script&lang=js"
export * from "./consolidar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports